import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { Sticky } from "react-sticky";
import Container from "src/react/layout/container";
import { color } from "src/styles/variables";

function StickyBanner({ backgroundColor = color.funGreen, children }) {
  return children ? (
    <div style={{ position: "relative", zIndex: 20 }}>
      <Sticky>
        {({ style, calculatedHeight }) => (
          <div style={calculatedHeight <= 100 ? style : null}>
            <Wrapper backgroundColor={backgroundColor}>
              <Container>{children}</Container>
            </Wrapper>
          </div>
        )}
      </Sticky>
    </div>
  ) : null;
}
StickyBanner.propTypes = {
  children: PropTypes.node,
  backgroundColor: PropTypes.string,
};

export default StickyBanner;

const Wrapper = styled.div`
  ${({ backgroundColor }) =>
    backgroundColor && `background-color: ${backgroundColor}`};
`;
